import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
// import "./add-details.css";
import { connect } from "react-redux";
import MaterialSize from "material-table";
import Spinner from "react-bootstrap/Spinner";
import MaterialTable from "material-table";

import { isEmpty } from "lodash";
import { baseURL, headers } from "../../../global/api";
import { ThemeProvider, createTheme } from "@mui/material";
import { deleteCurrency, getCurrency, updateCurrency } from "./Currency.action";
const ViewCurrency = (props) => {
  const defaultMaterialTheme = createTheme();
  const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some((p) => p[`${permissionsType}`] === permissionsName)
      ? false
      : true;
  };
  useEffect(() => {
    props.getCurrency();
    document.title = props.title;
    // console.log(props.couponsDataList, "list");
  }, []);
  return (
    <>
      {props.sFetchingCurrency ? (
        <div className="loader-div">
          <Spinner
            variant="secondary"
            animation="grow"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div
            className="main"
            style={{ height: "100%", backgroundColor: "#F9FAFB" }}
          >
            <ThemeProvider theme={defaultMaterialTheme}>
              <MaterialTable
                style={{
                  borderRadius: "30px",
                  boxShadow:
                    " 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                }}
                title="Currency Details"
                columns={[
                  { title: "Currency Id", field: "id", editable: "never" },
                  { title: "Currency Name", field: "name", editable: "never" },
                  { title: "Currency Sign", field: "sign", editable: "never" },
                  { title: "Currency Code", field: "code", editable: "never" },
                  { title: "Exchange Rate", field: "rate" },
                ]}
                data={props.currencyList}
                options={{
                  actionsColumnIndex: -1,
                  exportButton: true,
                  exportAllData: true,
                  paging: true,
                  pageSize: 50, // make initial page size
                  emptyRowsWhenPaging: false, // To avoid of having empty rows
                  pageSizeOptions: [20, 50, 100, 150, 200], // rows selection options
                  maxBodyHeight: "600px",
                  headerStyle: {
                    position: "sticky",
                    top: 0,
                    color: "#919EAB",
                    fontFamily: "Public Sans,sans-serif",
                    fontWeight: "550",
                    onRowAdd: "none",
                  },
                }}
                editable={{
                  isEditHidden: (rowData) =>
                    Checkpermissions("permissions_cat_name", "Currency Edit"),
                  onRowUpdate: (newData, oldData) =>
                    new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        {
                          props.updateCurrency(newData, oldData);
                        }
                      }, 600);
                    }),
                  // onRowDelete: (oldData) =>
                  //   new Promise((resolve) => {
                  //     setTimeout(() => {
                  //       resolve();
                  //       props.deleteCurrency(oldData.id);
                  //     }, 600);
                  //   }),
                }}
              />
            </ThemeProvider>
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCurrency: (data) => dispatch(getCurrency(data)),
    deleteCurrency: (currencyId) => dispatch(deleteCurrency(currencyId)),
    updateCurrency: (newData, oldData) =>
      dispatch(updateCurrency(newData, oldData)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  currencyList: state.CargoCurrencyReducer.currencyList,
  isFetchingCurrency: state.CargoCurrencyReducer.isFetchingCurrency,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCurrency);
